<div>
  <ng-container *ngIf="availabilityReport">
    <div class="mb-3" *ngFor="let stockAvailability of availabilityReport.stockAvailabilities">
      <h5 class="d-flex justify-content-between">
        <span>{{ 'AVAILABLE_FROM_STOCK' | translate }} - {{ stockAvailability.stockName }} :</span>
        <span class="pr-5">{{ stockAvailability.availableQuantity }}</span>
      </h5>
    </div>

    <div class="table-responsive">
      <div>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>{{ 'RESOURCE' | translate }}</th>
              <th>{{ 'QTY_AVAILABLE' | translate }}</th>
              <th>{{ 'ARRIVAL_DATE' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of availabilityReport.entries">
              <td>{{ item.type.split('from ')[1] }}</td>
              <td>{{ item.availableQuantity }}</td>
              <td>{{ item.arrivalDate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

  <div class="mt-5" (click)="generateAvailabilityReport()">
    <button class="btn btn-primary">{{ 'GENERATE_AVAILABILITY_REPORT' | translate }}</button>
  </div>
</div>
